import React, { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useBrandingLogo } from '../utils/GetLogo';
import Peoplehcm_logo from '../../images/black.svg';

export const BrandingLogo = ({ maxWidth = '100px', altText = 'Company Logo', styles }) => {
  const { logo, loading, isLogoAvailable } = useBrandingLogo();
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  // if (!isLogoAvailable) {
  //   return (
  //     <img
  //       src={Peoplehcm_logo}
  //       className={styles || ''}
  //       alt={altText}
  //       style={{
  //         maxWidth,
  //         height: 'auto',
  //       }}
  //     />
  //   );
  // }

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={0}
          height={0}></Box>
      ) : logo && !imageError ? (
        <img
          src={logo}
          className={styles || ''}
          alt={altText}
          style={{
            maxWidth,
            height: 'auto',
            display: isImageLoading ? 'none' : 'block',
          }}
          onLoad={() => setIsImageLoading(false)}
          onError={() => {
            setImageError(true);
            setIsImageLoading(false);
          }}
        />
      ) : (
        <Box color="gray" fontSize="16px"></Box>
      )}
    </Box>
  );
};
